import { t } from 'i18next'
import LocalStorage from 'services/LocalStorage'
import { LocalStorageKey } from 'types/services/localStorage'
import { is24meApp, isGroupcalApp } from './appType'
import { SUPPORT_EMAIL, SUPPORT_EMAIL_TFM } from './strings'
import UAParser from 'ua-parser-js'
import i18n from 'i18n'

export function isTestEnv() {
  return (
    process.env.REACT_APP_ENV === 'TESTING' ||
    process.env.REACT_APP_ENV === 'STAGING'
  )
}

export function isInIframe(): boolean {
  try {
    return window.self !== window.top || !!window.frameElement
  } catch {
    // Cross-origin access throws; assume iframe
    return true
  }
}

/**
 * Detects if the app is running as a Progressive Web App (installed)
 * Returns true if running as standalone/installed PWA, false if regular web browser
 */
export function isPWA(): boolean {
  // Check if running in standalone mode (iOS Safari, Chrome, etc.)
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches

  // iOS-specific check for standalone mode
  const isIOSStandalone = (window.navigator as any).standalone === true

  // Android/Chrome specific check
  const isDisplayModeStandalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    window.matchMedia('(display-mode: fullscreen)').matches ||
    window.matchMedia('(display-mode: minimal-ui)').matches

  return isStandalone || isIOSStandalone || isDisplayModeStandalone
}

export function browserDetails(): string {
  const deviceData = UAParser(window.navigator.userAgent)

  return (
    '%0D%0A' +
    `Browser: ${deviceData.browser.name}; ver: ${deviceData.browser.version}` +
    '%0D%0A' +
    `Language: ${i18n.language}` +
    '%0D%0A' +
    (is24meApp()
      ? `Email: ${LocalStorage.get(LocalStorageKey.USER_EMAIL)}`
      : `Phone: ${LocalStorage.get(LocalStorageKey.PHONE_NUMBER)}`) +
    '%0D%0A' +
    `Version: ${process.env.APP_VERSION}`
  )
}

export function sendEmailToUs() {
  const subject = t(isGroupcalApp() ? 'emailSubject' : 'emailSubjectTfm')

  window.open(
    `mailto:${
      isGroupcalApp() ? SUPPORT_EMAIL : SUPPORT_EMAIL_TFM
    }?subject=${subject}&body=${` %0D%0A%0D%0A%0D%0A%0D%0A Technical info for this report: ${browserDetails()}`}`
  )
}
